export default {
  monetization: {
    url: 'https://mc-reporting.spot.im/monetization_data',
    cdn: 'https://mc-reporting.spot.im/monetization_data'
  },
  emailConnect: {
    url: 'https://email-connect.spot.im',
    cdn: 'https://www.spot.im/api/email-connect'
  },
  extract: {
    url: 'https://extract.spot.im',
    cdn: 'https://www.spot.im/api/extract'
  },
  findUser: {
    url: 'https://find-user.spot.im',
    cdn: 'https://api-2-0.spot.im/v1.0.0/user/find-user'
  },
  general: {
    url: 'https://conversation.spot.im',
    cdn: 'https://www.spot.im/api'
  },
  me: {
    url: 'https://me.spot.im',
    cdn: 'https://www.spot.im/api/me'
  },
  moderation: {
    url: 'https://moderation.spot.im',
    cdn: 'https://www.spot.im/api/moderation'
  },
  newsfeedSync: {
    url: 'https://newsfeed-sync.spot.im',
    cdn: 'https://www.spot.im/api/newsfeed-sync'
  },
  notifications: {
    url: 'https://notifications.spot.im',
    cdn: 'https://www.spot.im/api/notifications'
  },
  openApi: {
    url: 'https://open-api.spot.im',
    cdn: 'https://www.spot.im/api/open-api'
  },
  publicUser: {
    url: 'https://public-user.spot.im',
    cdn: 'https://www.spot.im/api/public-user'
  },
  rank: {
    url: 'https://rank.spot.im',
    cdn: 'https://www.spot.im/api/rank'
  },
  recommendations: {
    url: 'https://recommendation.spot.im',
    cdn: 'https://www.spot.im/api/recommendation'
  },
  socialConnect: {
    url: 'https://social-connect.spot.im',
    cdn: 'https://www.spot.im/api/social-connect'
  },
  sso: {
    url: 'https://sso.spot.im',
    cdn: 'https://www.spot.im/api/sso'
  },
  tracker: {
    url: 'https://tracker.spot.im',
    cdn: 'https://www.spot.im/api/tracker'
  },
  topic: {
    url: 'https://topics.spot.im',
    cdn: 'https://www.spot.im/api/topics'
  },
  topicV2: {
    url: 'https://community-spoxy.spot.im',
    cdn: 'https://community-spoxy.spot.im'
  },
  eventsCollectorDeviceLoad: {
    url: 'https://events-collector.spot.im/api/v1/device_load',
    cdn: 'https://events-collector.spot.im/api/v1/device_load'
  },
  apiGw: {
    url: 'https://api-2-0.spot.im/v1.0.0',
    cdn: 'https://api-2-0.spot.im/v1.0.0'
  },
  init: {
    url: 'https://init.spot.im',
    cdn: 'https://init.spot.im'
  },
  tmsBE: 'https://api.spot.im/tms'
};
